import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import { DropTarget, DragDropContainer } from 'react-drag-drop-container';
import {StoreContext} from "../../stores/contexts";

class Dragger extends Component {
  static contextType = StoreContext;

  render() {
    const idField=this.context.configStore.config.data.id_field;
    return (
      <DragDropContainer
        // dragData={dragIds}
        noDragging={false}
        returnToBase={true}
        dragClone={false}
        targetKey="section"
        onDragStart={()=>{
          const dragIds=this.context.selectStore.getIds();
          const dragMap=toJS(this.context.selectStore.selected);
          if(!dragIds.length) {
            dragIds.push(this.props.row[idField]);
            dragMap[this.props.row[idField]]=true;
          }
          console.log('dragIds',dragIds);

          console.log("drag_start");
          this.context.dragStore.dragging=true;
          this.context.dragStore.drag_type="element";
          this.context.dragStore.drag_source={ids:dragIds,map:dragMap};
          this.context.communicatorStore.pushMessage({ type:"output",command:"drag_manual",data:{ type:"elements",ids:dragIds } });
        }}
        onDragEnd={()=>{
          this.context.dragStore.dragging=false;
          this.context.dragStore.drag_type="";
          this.context.dragStore.drag_source={};
          this.context.communicatorStore.pushMessage({ type:"output",command:"drag_manual" });
          console.log("DRAG END!!!");
        }}
        onDrop={(data)=>{
          console.log("DROP!!!",data);
        }}
        elementProps={{ style:{ display:'inline', position:'static'}}}
        customDragElement={(
          <div className="padd5 wsnw bg-w1 shadow" style={{width:100}}>Элементов: {this.context.selectStore.selectedCount>0?this.context.selectStore.selectedCount:1}</div>
        )}
      >
        <i className="mdi mdi-dots-vertical fs24 openhand pr op-hov dib b5" style={{ left: -12, top: 1, width:10 }}></i>
      </DragDropContainer>
    )
  }
}

// export default inject("dragStore","selectStore","communicatorStore","configStore")(observer(Dragger));
export default observer(Dragger);